import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ScreeningEntitiesInputParams } from '../utils/screening-entities.utils';

@Injectable({
  providedIn: 'root',
})
export class ScreeningInputParamsService {
  public screeningInputParams = signal<ScreeningEntitiesInputParams | null>(null);
  private _screeningEntitiesInputParams$ = new BehaviorSubject<ScreeningEntitiesInputParams | null>(
    this.screeningInputParams(),
  );
  public readonly screeningEntitiesInputParams$ = this._screeningEntitiesInputParams$.asObservable();

  public triggerScreeningEntitiesRefresh(
    screeningEntitiesInputParams: ScreeningEntitiesInputParams | null = this.screeningInputParams(),
  ): void {
    this.screeningInputParams.set(screeningEntitiesInputParams);
    this._screeningEntitiesInputParams$.next(this.screeningInputParams());
  }

  public patchScreeningEntitiesInputParams(screeningEntitiesInputParams: Partial<ScreeningEntitiesInputParams>): void {
    const currentScreeningInputParams = this.screeningInputParams();
    if (currentScreeningInputParams) {
      this.screeningInputParams.update(() => ({ ...currentScreeningInputParams, ...screeningEntitiesInputParams }));
      this._screeningEntitiesInputParams$.next(this.screeningInputParams());
    }
  }
}
